import { render, staticRenderFns } from "./add-service-choose.vue?vue&type=template&id=1c418c94&scoped=true&"
import script from "./add-service-choose.js?vue&type=script&lang=js&"
export * from "./add-service-choose.js?vue&type=script&lang=js&"
import style0 from "./add-service-choose.css?vue&type=style&index=0&id=1c418c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c418c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VList,VListItem,VListItemAvatar,VListItemContent,VListItemGroup,VListItemTitle})
